"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
const i0 = require("@angular/core");
const i1 = require("./cesium-map-viewer.component");
const i2 = require("../map-data.service");
const i3 = require("../map-event.service");
var styles_FourDMapComponent = [];
var RenderType_FourDMapComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_FourDMapComponent, data: {} });
exports.RenderType_FourDMapComponent = RenderType_FourDMapComponent;
function View_FourDMapComponent_0(_l) { return i0.ɵvid(0, [], null, null); }
exports.View_FourDMapComponent_0 = View_FourDMapComponent_0;
function View_FourDMapComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "fourd-map-view-component", [], null, null, null, View_FourDMapComponent_0, RenderType_FourDMapComponent)), i0.ɵdid(1, 245760, null, 0, i1.FourDMapComponent, [i0.ElementRef, i2.MapDataService, i3.MapEventService, i0.ElementRef], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_FourDMapComponent_Host_0 = View_FourDMapComponent_Host_0;
var FourDMapComponentNgFactory = i0.ɵccf("fourd-map-view-component,[fourd-map-view-component]", i1.FourDMapComponent, View_FourDMapComponent_Host_0, {}, {}, []);
exports.FourDMapComponentNgFactory = FourDMapComponentNgFactory;
